import { buildApiUrl, API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./apiUtils";

export function clearUserScopedStorage() {
  localStorage.removeItem("userType");
  localStorage.removeItem("selectedOrg");
  localStorage.removeItem("statusDataByOrg");
  localStorage.removeItem("statusData");

  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("planning_draft_")) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));

  sessionStorage.removeItem("user");
}

export async function stopImpersonation() {
  try {
    await apiRequest(buildApiUrl(API_ENDPOINTS.impersonationStop), {
      method: "POST",
    });
    clearUserScopedStorage();
    window.location.href = "/inicio";
  } catch (err) {
    if (err.status === 401) {
      clearUserScopedStorage();
      window.location.href = "/";
    } else {
      throw err;
    }
  }
}
